import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDmAuto = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 68.663 40.376",
	fill: "currentColor",
	stroke: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "DigitaltMuseum_Auto",
		transform: "translate(-1382.108 -860.362)",
		children: [/* @__PURE__ */ _jsxs("g", {
			id: "DM",
			transform: "translate(1399.878 874.564)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Combined-Shape",
					d: "M50.894,0V26.174H0V0ZM1.454,1.454V24.72H49.439V1.454Zm23.266,0h1.454V24.72H24.72Z",
					fillRule: "evenodd"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_993",
					"data-name": "Path 993",
					d: "M20.934,15.968a5.54,5.54,0,0,0-1.207-4.042,3.947,3.947,0,0,0-2.894-1.105H12.82V21.13h4.013a3.947,3.947,0,0,0,2.894-1.105,5.575,5.575,0,0,0,1.207-4.057Zm-1.9,0a4.064,4.064,0,0,1-.742,2.894,2.04,2.04,0,0,1-1.454.582H14.7V12.507h2.138a2.04,2.04,0,0,1,1.454.582,4.027,4.027,0,0,1,.742,2.879Z",
					transform: "translate(-3.499 -2.953)",
					fillRule: "evenodd"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_994",
					"data-name": "Path 994",
					d: "M55.233,21.13V10.82h-2.4l-2.719,7.343-2.7-7.343H44.88V21.13H46.7V13.685l2.661,7.3H50.74l2.676-7.212V21.13Z",
					transform: "translate(-12.25 -2.953)",
					fillRule: "evenodd"
				})
			]
		}), /* @__PURE__ */ _jsxs("g", {
			id: "Group_3228",
			"data-name": "Group 3228",
			transform: "translate(-13.56 381.656)",
			children: [/* @__PURE__ */ _jsx("path", {
				id: "magic_button_FILL0_wght300_GRAD0_opsz48",
				d: "M571.778-418.965l-1.9-4.27-4.259-1.909,4.252-1.938,1.911-4.225,1.955,4.225,4.225,1.938-4.227,1.909Z",
				transform: "translate(830.053 917.867)"
			}), /* @__PURE__ */ _jsx("path", {
				id: "magic_button_FILL0_wght300_GRAD0_opsz48-2",
				"data-name": "magic_button_FILL0_wght300_GRAD0_opsz48",
				d: "M570.036-422.455l-1.366-3.063-3.055-1.37,3.05-1.39,1.371-3.03,1.4,3.03,3.03,1.39-3.032,1.37Z",
				transform: "translate(837.969 910.014)"
			})]
		})]
	})
});
export default SvgDmAuto;
